export default class EitherOrResultsBreakdownModel {
  public rangeStartInclusive: number = 0;
  public rangeEndInclusive: number = 0;
  public totalUsers: number = 0;
}
